var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"multiple":true,"async":true,"load-options":_vm.loadOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }